module.exports = __webpack_public_path__ + "26dc75f2c2e0e3bdd7b2ad162ad54870.svg";